module.exports = __webpack_public_path__ + "img/icaro.30a623d0.png";